import {apiGet, apiPost} from '@api/api'
import {ApiRes} from '@type/api'
import {IProfile} from '@type/profile'
import {IConfirmResponse} from '@api/auths/register/Register'

export const apiFollow = async (user_id?: string): Promise<ApiRes<IConfirmResponse>> => {
    return await apiPost(`follow`, {followee_id: user_id})
}
